import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { emailRegex, FormState, phoneRegex } from '@opu/utils';
import { useHistory, useLocation } from 'react-router-dom';
import AxiosInstance from '../../helpers/AxiosInstance';
import { useTranslation } from 'react-i18next';
import { auth } from '../../firebase-init';

const useForm = () => {
    let history = useHistory();
    let location = useLocation();
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);

    const [responseValues, setResponseValues] = useState({
        firstName: '',
        lastName: '',
        email: '',
        gender: '',
        phone: '',
        role: '',
    });

    useEffect(() => {
        if (auth.currentUser.uid) {
            getOpuUser();
        }
    }, []);

    const back = () => {
        history.goBack();
    };

    const getOpuUser = () => {
        AxiosInstance.get('/auth/get-authenticated-user/' + auth.currentUser.uid)
            .then(async(response) => {
                const userClaims = await (await auth.currentUser.getIdTokenResult()).claims;

                const fallbackEmail = response.data.email || auth.currentUser?.email || '';

                let inputValues = {
                    firstName: response.data.firstName,
                    lastName: response.data.lastName,
                    email: fallbackEmail,
                    gender: response.data.gender,
                    phone: response.data.phone,
                    role: userClaims.role === 'admin' ?
                        'Administrateur' :
                        userClaims.role === 'ESTABLISHMENT_USER' ?
                        "Administrateur d'établissement" :
                        userClaims.role === 'commercial_admin' ?
                        'Administrateur Commercial' :
                        'Super Administrateur',
                };
                setResponseValues(inputValues);
                updateFormState(inputValues);
            })
            .catch((error) => {
                Swal.fire(t('ERROR_GET_PROFILE'), '', 'error');
            });
    };

    const updateOpuUser = async() => {
        const userClaims = await (await auth.currentUser.getIdTokenResult()).claims;
        const endPoint =
            userClaims.role === 'super_admin' ?
            '/opu-user/' :
            userClaims.role === 'admin' ?
            '/opu-user/update-profile/' :
            '/establishment-user/update-profile/';

        setLoading(true);
        AxiosInstance.patch(endPoint + userClaims.id, {
                firstName: formState.inputValues.firstName,
                lastName: formState.inputValues.lastName,
                gender: formState.inputValues.gender,
                email: formState.inputValues.email,
                phone: formState.inputValues.phone,
            })
            .then(async(res) => {
                Swal.fire(t('SUCCESS_UPDATE_PROFILE'), '', 'success');
                setLoading(false);
                auth.currentUser.updateProfile({ displayName: `${formState.inputValues.firstName} ${formState.inputValues.lastName}` });
            })
            .catch((error) => {
                if (error.status === 400) {
                    handleErrorsServer(error.data.message);
                } else Swal.fire(t('ERROR_UPDATE_PROFILE'), '', 'error');
                setLoading(false);
            });
    };

    const inputValues = {
        firstName: { value: '', validate: { required: true } },
        lastName: { value: '', validate: { required: true } },
        email: { value: '', validate: { required: true, pattern: emailRegex } },
        phone: { value: '', validate: { required: true, pattern: phoneRegex } },
        gender: { value: '', validate: { required: true } },
        role: { value: '', validate: { required: true } },
    };

    const sendPasswordResetEmail = () => {
        setLoading(true);

        if (auth.currentUser) {
            AxiosInstance.post(`/auth/send-password-recovery-email`, {
                email: auth.currentUser.email,
                role: 'admin',
                firebase_uid: auth.currentUser.uid,
            })
                .then((res) => {
                    Swal.fire(t('PASSWORD_RESET_SUCCESS'), '', 'success');
                })
                .catch((error) => {
                    Swal.fire(t('PASSWORD_RESET_FAILED'), '', 'error');
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    const { formState, submitHandler, updateFormState, field, handleErrorsServer } = FormState(inputValues, updateOpuUser);

    return {
        submitHandler,
        back,
        loading,
        field,
        responseValues,
        sendPasswordResetEmail,
    };
};

export default useForm;
